import { render } from "./quantities_edit.vue?vue&type=template&id=72be425f"
import script from "./quantities_edit.vue?vue&type=script&lang=js"
export * from "./quantities_edit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__